import Grid from "@mui/material/Grid2";
import { Box } from "@mui/material";
import { usePermissionsProvider } from "../../../auth/usePermissionsProvider";
import { useUserContext } from "../../../auth/userContextProvider/UserContextProvider";
import RiskDashboardWidget from "../../riskDashboardWidget/RiskDashboardWidget";
import RiskWidgetReport from "../riskWidgetReport/RiskWidgetReport";

export interface IComplianceReportRiskSectionProps {
    onlyUserSpecific: boolean;
    selectedGroupCompany: string | undefined;
}

// The report's risk page. Enterprise Risk Management prints one section covering every area, matching the dashboard
// widget; without the addon it prints the legacy processing-activity and asset sections unchanged.
function ComplianceReportRiskSection(props: IComplianceReportRiskSectionProps) {
    const { hasEnterpriseRiskManagementAccess } = usePermissionsProvider();
    const { showLegacyRiskAssessments } = useUserContext();

    if (!hasEnterpriseRiskManagementAccess) {
        // The legacy sections are the only risk content available here, so hiding the legacy feature
        // drops the report's risk page rather than printing an empty one.
        if (!showLegacyRiskAssessments) {
            return null;
        }

        return (
            <div className="page-break-before">
                <Box mt={2}>
                    <Grid container spacing={2}>
                        <Grid size={6}>
                            <RiskWidgetReport
                                onlyUserSpecific={props.onlyUserSpecific}
                                selectedGroupCompany={props.selectedGroupCompany}
                                isSystemChosen={false}
                            />
                        </Grid>

                        <Grid size={6}>
                            <RiskWidgetReport onlyUserSpecific={props.onlyUserSpecific} selectedGroupCompany={props.selectedGroupCompany} isSystemChosen />
                        </Grid>
                    </Grid>
                </Box>
            </div>
        );
    }

    return (
        <div className="page-break-before">
            <Box mt={2}>
                <Grid container spacing={2}>
                    <Grid size={6}>
                        <RiskDashboardWidget onlyUserSpecific={props.onlyUserSpecific} selectedGroupCompany={props.selectedGroupCompany} isPdf />
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
}

export default ComplianceReportRiskSection;
